/*
 * @Author: zemzheng zemzheng@tencent.com
 * @Date: 2024-07-24 17:04:17
 * @LastEditors: zemzheng zemzheng@tencent.com
 * @LastEditTime: 2024-09-24 15:32:25
 * @Description: 小程序内嵌页面登录态获取
 */
import { getParameterByName, removeParamFromUrl } from "./query";
import { miloCore } from '@tencent/milo-core';

// url 和 localStorage 里面存储的登录态
export var UP_LOGIN_PARAMS_KEY = 'upLoginParams';
/**
 * 后退按钮直接回到小程序，不然点击一次会跳到登录中间页，然后又进入 H5
 * @see https://developers.weixin.qq.com/community/develop/doc/0004e8faa689d81cfb1bd66c153c00
 */
var _ref = function () {
    var isUpMpBack = 'UP_MP_BACK';
    // 监听后退
    var inited = false;
    var listener = function listener(event) {
      var _event$state;
      // 判断是否命中小程序后退
      if (isUpMpBack === (event === null || event === void 0 || (_event$state = event.state) === null || _event$state === void 0 ? void 0 : _event$state.isUpMpBack)) {
        var _window;
        (_window = window) === null || _window === void 0 || (_window = _window.wx) === null || _window === void 0 || _window.miniProgram.navigateBack();
      }
    };
    var setBackToMp = function setBackToMp() {
      if (!inited) {
        inited = true;
        window.addEventListener('popstate', listener);
      }
      // 插入一个路由
      history.pushState({
        isUpMpBack: isUpMpBack
      }, document.title, window.location.href);
      // 恢复，避免进入下一个页面的后退被返回
      history.pushState(document.title, window.location.href);
    };
    var cancelBackToMp = function cancelBackToMp() {
      window.removeEventListener('popstate', listener);
      inited = false;
    };
    return {
      setBackToMp: setBackToMp,
      cancelBackToMp: cancelBackToMp
    };
  }(),
  setBackToMp = _ref.setBackToMp,
  cancelBackToMp = _ref.cancelBackToMp;

/**
 * @see https://developers.weixin.qq.com/miniprogram/dev/component/web-view.html#%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3-5
 * 相关接口 5
 * 从微信7.0.0开始，可以通过判断userAgent中包含miniProgram字样来判断小程序web-view环境。
 */
export { setBackToMp, cancelBackToMp };
var isInMp = /miniProgram/i.test(window.navigator.userAgent) || false;
export var checkIsInMp = function checkIsInMp() {
  return isInMp;
};
/**
 * @see https://developers.weixin.qq.com/miniprogram/dev/component/web-view.html#%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3-4
 * 相关接口 4
 * 在网页内可通过window.__wxjs_environment变量判断是否在小程序环境，建议在WeixinJSBridgeReady回调中使用，也可以使用JSSDK 1.3.2提供的getEnv接口。
 */
var checkRealIsInMpPromise = new Promise(function (resolve) {
  var _window$WeixinJSBridg;
  if (isInMp) return resolve(isInMp); // 微信 > 7.0.0
  var ready = function ready() {
    isInMp = window.__wxjs_environment === 'miniprogram';
    resolve(isInMp);
  };
  if (!((_window$WeixinJSBridg = window.WeixinJSBridge) !== null && _window$WeixinJSBridg !== void 0 && _window$WeixinJSBridg.invoke)) {
    document.addEventListener('WeixinJSBridgeReady', ready, false);
  } else {
    ready();
  }
});

/**
 * 如果特别重要，一定要精准判断是否内嵌在小程序内的话
 */
export var checkRealIsInMp = function checkRealIsInMp() {
  return checkRealIsInMpPromise;
};

/**
 * 确认是否需要微信自动登录
 * @param params
 */
export var checkIsNeedWxAutoLoginInMp = function checkIsNeedWxAutoLoginInMp(params) {
  return (params === null || params === void 0 ? void 0 : params.acctype) === 'wx' && params.isWxAutoLogin;
};

/**
 * 获取当前 url 上的 UpLoginParams
 */
export var getMpLoginParamsByUrl = function getMpLoginParamsByUrl() {
  if (!checkIsExistMpLoginParams()) return null;
  // 拿到 url 里面的登录设置
  var json = getParameterByName(UP_LOGIN_PARAMS_KEY);
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch (err) {
    console.error('utils/getMpLoginParamsByUrl', err);
  }
  return null;
};

/**
 * 要种入 cookie 的登录参数列表，用于校验
 * @see saveMpLoginParamsToCookie
 */
var loginKeys = ['access_token', 'acctype', 'appid', 'openid'];

/**
 * 将小程序透传给H5的登录参数存入 cookie
 * @param params
 */
export var saveMpLoginParamsToCookie = function saveMpLoginParamsToCookie(params) {
  if ((params === null || params === void 0 ? void 0 : params.acctype) !== 'qc') return;
  loginKeys.forEach(function (key) {
    var val = params[key];
    // 登录4要素逐个检查，必须有
    if (!val) throw new Error("".concat(UP_LOGIN_PARAMS_KEY, " miss ").concat(key));
    miloCore.cookie.set(key, val, 7200, location.host, '/');
  });
};

/**
 * 判断 URL 是否有接收到小程序登录态参数
 */
export var checkIsExistMpLoginParams = function checkIsExistMpLoginParams() {
  return location.href.match(UP_LOGIN_PARAMS_KEY);
};

/**
 * 清理掉登录参数避免鉴权信息泄漏
 */
export var cleanMpLoginParams = function cleanMpLoginParams() {
  if (checkIsExistMpLoginParams()) {
    history.replaceState(null, '', removeParamFromUrl(location.href, [UP_LOGIN_PARAMS_KEY]));
  }
};